<div class="w-full">
    <label for="employee" class="block text-sm font-semibold text-gray-800 mb-2">Assigned To</label>
    
    <!-- Dropdown button -->
    <button (click)="toggleDropdown(); $event.stopPropagation()" class="w-full flex justify-between items-center px-3 py-2 text-gray-900 border border-gray-300 rounded-lg bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-150 ease-in-out">
      <span>{{ selectedOption || 'Select an option' }}</span>
      <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
      </svg>
    </button>
  
    <!-- Dropdown content -->
    <div *ngIf="dropdownAssignedToOpen" class="border border-gray-300 rounded-lg bg-white mt-2 shadow-lg z-10 absolute w-full transition duration-200 ease-in-out">
      
      <!-- Search Input -->
      <input 
        type="text" 
        placeholder="Search..." 
        (input)="onSearchInput($event)" 
        class="appearance-none block w-full px-4 py-2 border-b border-gray-300 placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm mb-2 transition duration-150 ease-in-out">
      
      <!-- Dropdown Options -->
      <div class="max-h-60 overflow-y-auto">

    <!-- Users -->
        <div class="py-1 px-3">
            <h5 class="text-sm font-semibold text-gray-600 mb-1">Users</h5>
            <select id="employee" name="employee" [(ngModel)]="task.employee" required multiple class="block w-full px-3 py-2 bg-white text-gray-900 sm:text-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 rounded-lg shadow-sm">
                <option *ngFor="let req of filteredUsers" [ngValue]="req._id">{{ req.name }}</option>
            </select>
        </div>

        <!-- Global Groups -->
        <div class="py-1 px-3">
          <h5 class="text-sm font-semibold text-gray-600 mb-1">Global Groups</h5>
          <select id="employee" name="employee" [(ngModel)]="selectedOption" required multiple class="block w-full px-3 py-2 bg-white text-gray-900 sm:text-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 rounded-lg shadow-sm">
            <option *ngFor="let group of filteredGlobalGroups" [ngValue]="group._id">{{ group.name }}</option>
          </select>
        </div>
  
        <!-- Private Groups -->
        <div class="py-1 px-3">
          <h5 class="text-sm font-semibold text-gray-600 mb-1">Private Groups</h5>
          <select id="employee" name="employee" [(ngModel)]="selectedOption" required multiple class="block w-full px-3 py-2 bg-white text-gray-900 sm:text-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 rounded-lg shadow-sm">
            <option *ngFor="let group of filteredPrivateGroups" [ngValue]="group._id">{{ group.name }}</option>
          </select>
        </div>
  
        
      </div>
    </div>
  </div>
  